import React from 'react';
import './ui.css';

const VARIANT_CLASS = {
  default: 'pn-card--default',
  grid: 'pn-card--grid',
  stat: 'pn-card--stat',
  highlight: 'pn-card--highlight',
  auth: 'pn-card--auth',
  marketing: 'pn-card--marketing',
  'marketing-static': 'pn-card--marketing pn-card--marketing-static',
  'marketing-expandable': 'pn-card--marketing pn-card--marketing-expandable',
};

const PADDING_CLASS = {
  sm: 'pn-card--pad-sm',
  md: '',
  lg: 'pn-card--pad-lg',
};

/**
 * Card unificado — superfícies app e marketing.
 * @see Docs/design-system/PADRAO_cards.md
 */
const Card = ({
  children,
  title,
  headerAction,
  variant = 'default',
  highlight = false,
  className = '',
  accentColor,
  icon,
  iconBg,
  expandable,
  expanded,
  onToggle,
  onClick,
  padding = 'md',
  as: Tag = 'div',
  ...rest
}) => {
  const resolvedVariant = highlight ? 'highlight' : variant;
  const variantClass = VARIANT_CLASS[resolvedVariant] || VARIANT_CLASS.default;
  const padClass = PADDING_CLASS[padding] || '';
  const isExpandable = expandable || resolvedVariant === 'marketing-expandable';
  const isStat = resolvedVariant === 'stat';
  const statHighlightClass = isStat && highlight ? 'pn-card--stat-highlight' : '';
  const isGrid = resolvedVariant === 'grid';

  const classes = [
    'pn-card',
    variantClass,
    statHighlightClass,
    padClass,
    isExpandable && expanded ? 'is-expanded' : '',
    isExpandable ? 'is-expandable' : '',
    onClick || (isExpandable && onToggle) ? 'is-clickable' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style = accentColor
    ? { '--pn-card-accent': accentColor, borderTopColor: accentColor }
    : undefined;

  const handleClick = (e) => {
    if (isExpandable && onToggle) onToggle(e);
    else if (onClick) onClick(e);
  };

  const headerContent =
    title || headerAction || icon ? (
      <div
        className={`pn-card__header ${isExpandable ? 'pn-card__header--expandable' : ''}`}
        onClick={isExpandable && onToggle ? handleClick : undefined}
        onKeyDown={
          isExpandable && onToggle
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onToggle(e);
                }
              }
            : undefined
        }
        role={isExpandable && onToggle ? 'button' : undefined}
        tabIndex={isExpandable && onToggle ? 0 : undefined}
      >
        {isStat || isGrid ? (
          <div className="pn-card__header-left">
            {icon ? (
              <div
                className="pn-card__icon-wrap"
                style={iconBg ? { backgroundColor: iconBg } : undefined}
              >
                {icon}
              </div>
            ) : null}
            {title ? (
              typeof title === 'string' ? (
                <h3 className="pn-card__title">{title}</h3>
              ) : (
                title
              )
            ) : null}
          </div>
        ) : (
          <>
            {title ? (
              typeof title === 'string' ? (
                <h3 className="pn-card__title">{title}</h3>
              ) : (
                title
              )
            ) : (
              <span />
            )}
          </>
        )}
        {headerAction}
      </div>
    ) : null;

  return (
    <Tag
      className={classes}
      style={style}
      onClick={!isExpandable && onClick ? handleClick : undefined}
      {...rest}
    >
      {headerContent}
      {children}
    </Tag>
  );
};

export default Card;
